// extracted by mini-css-extract-plugin
export default {"container":"Perfil_container__rgbEx","profileCard":"Perfil_profileCard__qrb4V","cardHeader":"Perfil_cardHeader__RMln6","infoGroup":"Perfil_infoGroup__Gs+2+"};